import React, { useState } from 'react';
import './Requester.css';
import Button from '../../components/button';
import CustomPaginationTable from '../../components/table/CustomPaginationTable';
import Form from '../../components/customForm/Form';
import AddIcon from '../../static/image/addIcon.svg';
import AddRequest from './AddRequest';
import SendRequestModal from './SendRequestModal';
import DeleteRequestModal from './DeleteRequestModal';

function Requester() {
  const columns = [
    {
      name: 'Req ID',
      cell: (row, index) => (
        <>
          <div>{row.reqId}</div>
        </>
      ),
    },
    {
      name: 'SKU',
      cell: (row, index) => (
        <>
          <div>{row.sku}</div>
        </>
      ),
    },
    {
      name: 'Product Name',
      cell: (row, index) => (
        <>
          <div>{row.productName}</div>
        </>
      ),
    },
    {
      name: 'Category',
      cell: (row, index) => (
        <>
          <div>{row.category}</div>
        </>
      ),
    },
    {
      name: 'Retail Price',
      cell: (row, index) => (
        <>
          <div>{row.retailPrice}</div>
        </>
      ),
    },
    {
      name: 'Discounted Price',
      cell: (row, index) => (
        <>
          <div>{row.discountedPrice}</div>
        </>
      ),
    },
    {
      name: 'Promo Start Date',
      cell: (row, index) => (
        <>
          <div>{row.promoStartDate}</div>
        </>
      ),
    },
    {
      name: 'Promo End Date',
      cell: (row, index) => (
        <>
          <div>{row.promoEndDate}</div>
        </>
      ),
    },
    {
      name: 'Status',
      cell: (row, index) => (
        <>
          <div>{row.status}</div>
        </>
      ),
    },
    {
      name: 'After Discountered Price',
      cell: (row, index) => (
        <>
          <div>{row.afterDiscountedPrice}</div>
        </>
      ),
    },
    {
      name: 'Actions',
      cell: (row, index) => (
        <div>
          <Button
            className='send-request-btn'
            onClick={() => handleSendRequestClick(row)}
          >
            SEND REQUEST
          </Button>
          <Button
            className='send-request-btn'
            style={{ marginTop: '10px' }}
            onClick={() => handleDeleteRequestClick(row)}
          >
            DELETE
          </Button>
        </div>
      ),
      sortable: false
    },
  ];

  const [data, setData] = useState([
    {
      reqId: '1',
      sku: 'SKU001',
      productName: 'Product A',
      category: 'Category 1',
      retailPrice: '$100',
      discountedPrice: '$80',
      promoStartDate: '21 Jun 2024 11:05:59',
      promoEndDate: '21 Jun 2024 11:05:59',
      status: 'Active',
      afterDiscountedPrice: '$80'
    },
    {
      reqId: '2',
      sku: 'SKU001',
      productName: 'Product A',
      category: 'Category 1',
      retailPrice: '$100',
      discountedPrice: '$80',
      promoStartDate: '21 Jun 2024 11:05:59',
      promoEndDate: '21 Jun 2024 11:05:59',
      status: 'Active',
      afterDiscountedPrice: '$80'
    }
  ]);

  const [isAddRequesOpen, setIsAddRequesOpen] = useState(false);
  const [showSendRequestModal, setShowSendRequestModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [showDeleteRequestModal, setShowDeleteRequestModal] = useState(false);

  const handleAddRequestClick = () => {
    setIsAddRequesOpen(true);
  };

  const handleCancel = () => {
    setIsAddRequesOpen(false);
  };

  const handleSendRequestClick = (row) => {
    setSelectedRequest(row);
    setShowSendRequestModal(true);
  };

  const handleCloseSendRequestModal = () => {
    setShowSendRequestModal(false);
  };

  const handleConfirmSendRequest = () => {
    setShowSendRequestModal(false);
  };

  const handleDeleteRequestClick = (row) => {
    setSelectedRequest(row);
    setShowDeleteRequestModal(true);
  };

  const handleCloseDeleteRequestModal = () => {
    setShowDeleteRequestModal(false);
  };

  const handleConfirmDeleteRequest = () => {
    setShowDeleteRequestModal(false);
    const newData = data.filter(item => item.reqId !== selectedRequest.reqId);
    setData(newData);
  };

  return (
    <div className="manage-user-container">
      {!isAddRequesOpen && (
        <div style={{ padding: '30px' }}>
          Discounted RRP Requester
          <Form />
          <div style={{ display: 'flex', marginTop: '20px' }}>
            <Button className='requester-add-request-btn' onClick={handleAddRequestClick}>
              <img src={AddIcon} style={{ marginRight: '5px' }} alt="Add" />
              ADD REQUEST
            </Button>
            <div style={{ marginLeft: 'auto', display: 'flex' }}>
              <Button className='requester-search-btn' style={{ marginRight: '10px' }}>
                SEARCH
              </Button>
              <Button className='requester-search-btn'>
                RESET
              </Button>
            </div>
          </div>

          <div style={{ marginTop: '20px' }}>
            <CustomPaginationTable
              columns={columns}
              data={data} />
          </div>
        </div>
      )}
      {isAddRequesOpen && <AddRequest onCancel={handleCancel} />}

      <SendRequestModal
        show={showSendRequestModal}
        onHide={handleCloseSendRequestModal}
        selectedRequest={selectedRequest}
        onConfirm={handleConfirmSendRequest}
      />

      <DeleteRequestModal
        show={showDeleteRequestModal}
        onHide={handleCloseDeleteRequestModal}
        selectedRequest={selectedRequest}
        onConfirm={handleConfirmDeleteRequest}
      />
    </div>
  );
}

export default Requester;
